/**
 *
 * FNAnalysisFNStatementsBalanceSheet
 *
 */

import React, { Component } from "react";

import { getRequest } from "../api/ApiService";
import { logError } from "../services/utils";

import HelpIconButtonWithTooltipAndTypeformModal from "../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../components/typeform/TypeformContent";

// Components

/**
 * Price in millions.
 */
const PriceInMillions = ({ price, baseClassName }) => {
  if (typeof price !== "number") {
    return <div className={baseClassName}>n/a</div>;
  }

  let newPrice;
  if (price < 0) {
    newPrice = (price / 1000000).toFixed(2) * -1;
    return (
      <div className={`font-red ${baseClassName}`}>{`-$${newPrice}M`}</div>
    );
  } else {
    newPrice = (price / 1000000).toFixed(2);
    return <div className={baseClassName}>{`$${newPrice}M`}</div>;
  }
};

/**
 * Table Head
 */

const TableHead = ({ rounds }) => (
  <thead>
    <tr>
      <th className="table-title text-center">
        <span />
      </th>
      {rounds.map((round, i) => (
        <th key={i} className="table-title title-gray text-center">
          YEAR {round.number}
        </th>
      ))}
    </tr>
  </thead>
);

/**
 * Table row contents
 */
const TableRowContentWhite = ({ balanceSheet }) => (
  <tr className="text-center">
    <th className="description">{balanceSheet.name}</th>
    {Object.keys(balanceSheet.data).map(round_number => {
      let data = balanceSheet.data[round_number];
      return (
        <td key={round_number}>
          <PriceInMillions baseClassName="text-center" price={data.value} />
        </td>
      );
    })}
  </tr>
);

/**
 * Table row contents with gray background color.
 */

const TableRowContentGray = ({ balanceSheet, title = "" }) => (
  <tr className="text-center bg-gray none-shadow">
    <th className="description">{title !== "" ? title : balanceSheet.name}</th>
    {Object.keys(balanceSheet.data).map(round_number => {
      let data = balanceSheet.data[round_number];
      return (
        <td key={round_number}>
          <PriceInMillions baseClassName="text-center" price={data.value} />
        </td>
      );
    })}
  </tr>
);

/**
 * Table row contents with dim gray background color.
 */

const TableRowContentDimGray = ({ balanceSheet }) => (
  <tr className="text-center dim-gray none-shadow">
    <th className="description">
      <strong>{balanceSheet.name}</strong>
    </th>
    {Object.keys(balanceSheet.data).map(round_number => {
      let data = balanceSheet.data[round_number];
      return (
        <td key={round_number}>
          <PriceInMillions baseClassName="text-center" price={data.value} />
        </td>
      );
    })}
  </tr>
);

/**
 * Table row title.
 */

const TableRowContentHeader = ({ title, rounds }) => (
  <tr className="text-center">
    <th className="sub-title title-sky-blue">{title}</th>
    {rounds.map((round, i) => (
      <td key={i}>
        <div className="row flex">
          <div className="col-xs-6" />
          <div className="col-xs-6" />
          <div className="col-xs-6" />
        </div>
      </td>
    ))}
  </tr>
);

/**
 * Table row sub header.
 */

const TableRowContentSubheader = ({ title, rounds }) => (
  <tr className="text-center">
    <th className="sub-title">{title}</th>
    {rounds.map((round, i) => (
      <td key={i}>
        <div className="row flex">
          <div className="col-xs-6" />
          <div className="col-xs-6" />
          <div className="col-xs-6" />
        </div>
      </td>
    ))}
  </tr>
);

/**
 *
 * FNAnalysisFNStatementsBalanceSheet
 *
 */
class FNAnalysisFNStatementsBalanceSheet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roundInUrl: props.roundInUrl,
      balanceSheet: {
        accountsPayable: {
          name: "Accounts Payable",
          data: {}
        },
        accountsReceivable: {
          name: "Accounts Receivable",
          data: {}
        },
        accruedExpenses: {
          name: "Accrued Expenses",
          data: {}
        },
        accumulatedDepreciation: {
          name: "Accumulated Depreciation",
          data: {}
        },
        additionalPaidinCapital: {
          name: "Additional Paid in Capital",
          data: {}
        },
        begRetainedEarnings: {
          name: "Prior Period Retained Earnings",
          data: {}
        },
        cash: {
          name: "Cash",
          data: {}
        },
        commonStock: {
          name: "Common Stock",
          data: {}
        },
        currentLiabilities: {
          name: "Current Liabilities:",
          data: {}
        },
        deferredRevenues: {
          name: "Deferred Revenues",
          data: {}
        },
        dividends: {
          name: "Dividends",
          data: {}
        },
        inventory: {
          name: "Inventory",
          data: {}
        },
        longTermDebt: {
          name: "Long Term Debt",
          data: {}
        },
        longTermLiabilities: {
          name: "Long Term Liabilities:",
          data: {}
        },
        netIncome: {
          name: "Net Income",
          data: {}
        },
        otherCurrentLiabilities: {
          name: "Other Current Liabilities",
          data: {}
        },
        otherLongTermLiabilities: {
          name: "Other Long Term Liabilities",
          data: {}
        },
        ppe: {
          name: "PPE",
          data: {}
        },
        preferredStock: {
          name: "Preferred Stock",
          data: {}
        },
        prepaidExpenses: {
          name: "Prepaid Expenses",
          data: {}
        },
        shortTermDebt: {
          name: "Short Term Debt",
          data: {}
        },
        supplies: {
          name: "Supplies",
          data: {}
        },
        totalAssets: {
          name: "Total Assets",
          data: {}
        },
        totalCurrentAssets: {
          name: "Total Current Assets",
          data: {}
        },
        totalCurrentLiabilities: {
          name: "Total Current Liabilities",
          data: {}
        },
        totalEquity: {
          name: "Total Equity",
          data: {}
        },
        totalLiabilities: {
          name: "Total Liabilities",
          data: {}
        },
        totalLongTermAssets: {
          name: "Total Long Term Assets",
          data: {}
        },
        totalLongTermLiabilities: {
          name: "Total Long Term Liabilities",
          data: {}
        }
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.roundInUrl !== nextProps.roundInUrl) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl
        },
        () => {
          this.loadState();
        }
      );
    }
  }

  getBalanceSheet() {
    const base_url = `${process.env.REACT_APP_API_URL}team/report/balance_sheet/`;
    let url = `${base_url}?round_lte=${this.props.currentRound}`;
    if (
      this.state.roundInUrl !== null &&
      this.state.roundInUrl !== this.props.currentRound
    ) {
      url = `${base_url}?round_lte=${this.state.roundInUrl}`;
    }

    return getRequest(url);
  }

  loadState = () => {
    if (this.props.rounds.length === 0) {
      this.timer = setTimeout(this.loadState, 1000);
      return;
    }

    this.clearData();
    this.fetchData();
  };

  clearData() {
    let balanceSheet = { ...this.state.balanceSheet };
    let headRounds = this.headRounds;

    for (let key in balanceSheet) {
      balanceSheet[key].data = {};
      headRounds.forEach(round => {
        balanceSheet[key].data[round.number] = {
          value: 0
        };
      });
    }

    this.setState({
      balanceSheet
    });
  }

  fetchData() {
    this.getBalanceSheet()
      .then(res => {
        const balanceSheet = { ...this.state.balanceSheet };

        for (let key in balanceSheet) {
          res.body.forEach(item => {
            let round_id = item.round;
            let round = this.props.rounds.find(i => i.id === round_id);
            let round_number = round.number;
            const hash = balanceSheet[key].name;

            if (item[hash]) {
              balanceSheet[key].data[round_number].value = item[hash];
            }
          });
        }

        this.setState({
          balanceSheet
        });
      })
      .catch(err => {
        logError(err, "FNAnalysisFNStatementsBalanceSheet", "fetchData");
      });
  }

  componentDidMount() {
    this.loadState();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      return;
    }
  }

  get headRounds() {
    const { roundInUrl } = this.state;
    const { currentRound, rounds } = this.props;

    let current_round = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_round = roundInUrl;
    }

    return rounds.filter(i => i.number <= current_round);
  }

  render() {
    const {
      accountsPayable,
      accountsReceivable,
      accruedExpenses,
      accumulatedDepreciation,
      additionalPaidinCapital,
      begRetainedEarnings,
      cash,
      commonStock,
      deferredRevenues,
      dividends,
      inventory,
      longTermDebt,
      netIncome,
      otherCurrentLiabilities,
      otherLongTermLiabilities,
      ppe,
      preferredStock,
      prepaidExpenses,
      shortTermDebt,
      supplies,
      totalAssets,
      totalCurrentAssets,
      totalCurrentLiabilities,
      totalEquity,
      totalLiabilities,
      totalLongTermAssets,
      totalLongTermLiabilities
    } = this.state.balanceSheet;
    const headRounds = this.headRounds;

    return (
      <div className="panel-dashboard-white-full">
        <h5 className="title-sky-blue">
          Balance Sheet
          <HelpIconButtonWithTooltipAndTypeformModal
            iconSize="sm"
            {...TypeformContent.BALANCE_SHEET}
          />
        </h5>
        <div className="table-responsive fn-results-table">
          <table className="table border-analysis mb-20">
            <TableHead rounds={headRounds} />
            {Object.keys(accountsPayable.data).length > 0 ||
            Object.keys(accountsReceivable.data).length > 0 ||
            Object.keys(accruedExpenses.data).length > 0 ? (
              <tbody>
                <TableRowContentSubheader
                  title="Current Assets:"
                  rounds={headRounds}
                />
                <TableRowContentGray balanceSheet={cash} />
                <TableRowContentWhite balanceSheet={accountsReceivable} />
                <TableRowContentGray balanceSheet={inventory} />
                <TableRowContentWhite balanceSheet={prepaidExpenses} />
                <TableRowContentGray balanceSheet={supplies} />
                <TableRowContentDimGray balanceSheet={totalCurrentAssets} />
                <TableRowContentSubheader title="" rounds={headRounds} />
                <TableRowContentSubheader
                  title="Long Term Assets:"
                  rounds={headRounds}
                />
                <TableRowContentGray balanceSheet={ppe} />
                <TableRowContentWhite balanceSheet={accumulatedDepreciation} />
                <TableRowContentSubheader title="" rounds={headRounds} />
                <TableRowContentDimGray balanceSheet={totalLongTermAssets} />
                <TableRowContentHeader title="" rounds={headRounds} />
                <TableRowContentDimGray balanceSheet={totalAssets} />
                <TableRowContentHeader title="" rounds={headRounds} />
                <TableRowContentHeader
                  title="Liabilities"
                  rounds={headRounds}
                />
                <TableRowContentSubheader
                  title="Current Liabilities"
                  rounds={headRounds}
                />
                <TableRowContentGray balanceSheet={deferredRevenues} />
                <TableRowContentWhite balanceSheet={accountsPayable} />
                <TableRowContentGray balanceSheet={accruedExpenses} />
                <TableRowContentWhite balanceSheet={shortTermDebt} />
                <TableRowContentGray balanceSheet={otherCurrentLiabilities} />
                <TableRowContentDimGray
                  balanceSheet={totalCurrentLiabilities}
                />
                <TableRowContentHeader title="" rounds={headRounds} />
                <TableRowContentSubheader
                  title="Long Term Liabilities"
                  rounds={headRounds}
                />
                <TableRowContentGray balanceSheet={longTermDebt} />
                <TableRowContentWhite balanceSheet={otherLongTermLiabilities} />
                <TableRowContentHeader title="" rounds={headRounds} />
                <TableRowContentDimGray
                  balanceSheet={totalLongTermLiabilities}
                />
                <TableRowContentHeader title="" rounds={headRounds} />
                <TableRowContentDimGray balanceSheet={totalLiabilities} />
                <TableRowContentHeader title="" rounds={headRounds} />
                <TableRowContentHeader title="Equity" rounds={headRounds} />
                <TableRowContentGray balanceSheet={commonStock} />
                <TableRowContentWhite balanceSheet={preferredStock} />
                <TableRowContentGray balanceSheet={additionalPaidinCapital} />
                <TableRowContentHeader
                  title="Retained Earnings:"
                  rounds={headRounds}
                />
                <TableRowContentGray
                  balanceSheet={begRetainedEarnings}
                  title="Beg Retained Earnings"
                />
                <TableRowContentWhite balanceSheet={netIncome} />
                <TableRowContentGray balanceSheet={dividends} />
                <TableRowContentDimGray balanceSheet={totalEquity} />
              </tbody>
            ) : (
              <tbody />
            )}
          </table>
        </div>
      </div>
    );
  }
}

export default FNAnalysisFNStatementsBalanceSheet;



// WEBPACK FOOTER //
// ./src/containers/FNAnalysisFNStatementsBalanceSheet.js